import { render } from "./SplitByBioModal.vue?vue&type=template&id=80081f2a&scoped=true&lang=pug"
import script from "./SplitByBioModal.vue?vue&type=script&lang=js"
export * from "./SplitByBioModal.vue?vue&type=script&lang=js"

import "./SplitByBioModal.vue?vue&type=style&index=0&id=80081f2a&lang=scss&scoped=true"
import "./SplitByBioModal.vue?vue&type=style&index=1&id=80081f2a&lang=css"
const cssModules = {}
import style2 from "./SplitByBioModal.vue?vue&type=style&index=2&id=80081f2a&lang=scss&module=true"
cssModules["$style"] = style2

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules],['__scopeId',"data-v-80081f2a"]])

export default __exports__